import React from 'react';
import './OurTeam.css';

const teamData = [
  {
    id: 1,
    name: 'Simran Bhatia',
    role: 'Senior Technical project Manager',
    imageUrl: '/images/OurTeam/SimranBhatia2.png',
    socials: { linkedin: '#', twitter: '#' },
  },
  {
    id: 2,
    name: 'Mahek Narang',
    role: 'Technical and Decorative project manager',
    imageUrl: '/images/OurTeam/MahekNarang2.png',
    socials: { linkedin: '#', dribbble: '#' },
  },
  {
    id: 3,
    name: 'Mital Ahir',
    role: 'Technical Project Manager',
    imageUrl: '/images/OurTeam/MitalAhir2.png',
    socials: { linkedin: '#', github: '#' },
  },
  {
    id: 4,
    name: 'Mital Mungra',
    role: 'Senior Technical Project Manager',
    imageUrl: '/images/OurTeam/MitalMungra2.png',
    socials: { linkedin: '#', twitter: '#' },
  },
];

// Reusable SVG Icon Component
const SocialIcon = ({ type }) => {
    const icons = {
        linkedin: ( <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452z"></path></svg> ),
        twitter: ( <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.643 4.937c-.835.37-1.732.62-2.675.733a4.67 4.67 0 002.048-2.578 9.3 9.3 0 01-2.958 1.13a4.66 4.66 0 00-7.938 4.25 13.229 13.229 0 01-9.602-4.868c-.353.61-.555 1.32-.555 2.064a4.658 4.658 0 002.066 3.861 4.661 4.661 0 01-2.105-.582v.06a4.658 4.658 0 003.737 4.568 4.692 4.692 0 01-2.098.08 4.658 4.658 0 004.35 3.234 9.348 9.348 0 01-5.786 1.995c-.376 0-.747-.022-1.112-.065a13.175 13.175 0 007.14 2.093c8.57 0 13.255-7.098 13.255-13.254 0-.202-.005-.403-.014-.602a9.47 9.47 0 002.323-2.41z"></path></svg> ),
        github: ( <svg viewBox="0 0 24 24" fill="currentColor"><path fillRule="evenodd" d="M12 2C6.477 2 2 6.477 2 12c0 4.418 2.865 8.165 6.839 9.489.5.092.682-.218.682-.482 0-.237-.009-.868-.014-1.703-2.782.604-3.369-1.342-3.369-1.342-.455-1.157-1.11-1.465-1.11-1.465-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.089 2.91.833.091-.647.35-1.089.635-1.34-2.22-.253-4.555-1.112-4.555-4.943 0-1.091.39-1.984 1.03-2.682-.103-.253-.446-1.27.098-2.646 0 0 .84-.269 2.75 1.025A9.548 9.548 0 0112 6.836c.85.004 1.705.115 2.504.336 1.909-1.294 2.748-1.025 2.748-1.025.546 1.376.202 2.393.1 2.646.64.698 1.028 1.591 1.028 2.682 0 3.84-2.337 4.687-4.565 4.935.359.307.678.915.678 1.846 0 1.334-.012 2.41-.012 2.736 0 .267.18.577.688.482A10.001 10.001 0 0022 12c0-5.523-4.477-10-10-10z" clipRule="evenodd"></path></svg> ),
        dribbble: ( <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zM3.633 13.91c.214-3.513 1.593-6.68 3.65-9.206a9.556 9.556 0 01-3.617 8.356.6.6 0 01-.033.85zm12.983 5.483C15.42 20.373 13.723 21 12 21c-1.34 0-2.61-.433-3.687-1.18l8.3-8.3c.747 1.077 1.187 2.347 1.187 3.68 0 1.724-.627 3.42-1.617 4.603zM20.25 10.32c-.524-4.22-3.13-7.85-6.815-9.742a9.55 9.55 0 017.394 6.912.602.602 0 01-.58 2.83zm-8.243-5.26a.6.6 0 01.32.146l5.77 4.328a.6.6 0 01.072.883 9.593 9.593 0 01-5.186 2.595.6.6 0 01-.68-.316 9.601 9.601 0 01-1.343-5.83.6.6 0 01.9- .56zM8.31 18.814a9.646 9.646 0 01-3.69-5.918l5.887 5.888a.602.602 0 01-.132.964c-.382.164-.78.3-1.188.411a.6.6 0 01-.637-.622c-.08-.4-.148-.804-.2-1.218a.596.596 0 01.042-.23l-.11-.005z"></path></svg> )
    };
  return <a href={type.url} aria-label={type.name} target="_blank" rel="noopener noreferrer">{icons[type.name]}</a>;
};


const OurTeam = () => {
  return (
    <section className="our-team-section-v4">
      <div className="section-header-v4">
        <h1>Meet Our Team</h1>
      </div>
      <div className="team-grid-v4">
        {teamData.map((member, index) => (
          <div
            key={member.id}
            className="team-card-v4"
            style={{ animationDelay: `${index * 150}ms` }}
          >
            <div className="photo-container-v4">
              <img src={member.imageUrl} alt={member.name} />
            </div>
            <div className="card-details-v4">
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              {/* <div className="social-links-v4">
                {Object.entries(member.socials).map(([name, url]) => (
                   <SocialIcon key={name} type={{ name, url }} />
                ))}
              </div> */}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurTeam;